import { FieldContentNode, ListContentNode } from '@helo/cms'

import { ListRenderer } from '../../../datatypes/list/ListRenderer'
import { CellRendererProps } from '../table.types'

export const ListCell = ({
  contentNode,
}: CellRendererProps<[] | null> & {
  contentNode: FieldContentNode
}) => {
  return (
    <ListRenderer
      contentNode={contentNode.ofType as ListContentNode}
      disableLoadingSkeletons
    />
  )
}
